import { LogLevel } from '../../types/logLevel';
import { Payload } from '../../types/payload';
import { config } from '../../config/config';
import { logToConsole } from './logToConsole';
import { logToServer } from './logToServer';

export function log(level: LogLevel, message: string, payload: Payload) {
  if (config.logToConsole) {
    logToConsole(level, message, payload);
  }

  if (config.loggingFilters.every((filter) => filter(message, payload))) {
    logToServer(level, message, payload);
  }
}
